
<template>
  <div class="btn-know ft-16"
    :class="{ dark }">{{$t('btn1')}}</div>
</template>

<script>
export default {
  props: {
    dark: Boolean
  }
}
</script>

<style lang="scss" scoped>
.btn-know {
  cursor: pointer;
  width: 166px;
  height: 64px;
  color: #fff;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-know.dark {
  color: #000;
  border-color: #000;
}
</style>
